// extracted by mini-css-extract-plugin
export var dropdownButton = "_1v-0";
export var fullWidthDropdownButton = "_1v-1";
export var icon = "_1v-3";
export var iconPlaceholder = "_1v-2";
export var shortcutContainer = "_1v-4";